import Logo from '~/assets/logos/logo.svg';
import { useHomeUrl } from '~/features/navigation/utils/useHomeUrl';
import Link from '~/shared/components/Link/Link';
import { useNavigation } from '~/shared/utils/navigation/hooks/useNavigation';

import styles from './mainMenuLogo.module.css';

const MainMenuLogo = () => {
	const {
		data: { header: { tagLine } = {} },
	} = useNavigation();

	return (
		<Link
			className={styles.root}
			href={useHomeUrl()}
		>
			<Logo className={styles.logo} />
			<span className={styles.tagLine}>{tagLine}</span>
		</Link>
	);
};

export default MainMenuLogo;
